var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';

var useStyles = makeStyles(function (theme) {
  var color1 = R.path(['palette', 'highlight', 'hl1'], theme) || theme.palette.primary.dark;

  return {
    defaultSelected: {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: theme.palette.action.selected + ' !important'
      }
    },
    sisccRoot: {
      '&:hover': _extends({
        color: theme.palette.getContrastText(color1),
        backgroundColor: R.path(['palette', 'highlight', 'hl1'], theme) || theme.palette.primary.dark
      }, R.path(['mixins', 'toggleButton', 'hover'])(theme))
    },
    sisccSelected: _extends({
      color: theme.palette.getContrastText(color1),
      backgroundColor: color1
    }, R.path(['mixins', 'toggleButton', 'selected'])(theme))
  };
});

var MyButton = React.forwardRef(function (_ref, ref) {
  var _cx;

  var className = _ref.className,
      selected = _ref.selected,
      _ref$alternative = _ref.alternative,
      alternative = _ref$alternative === undefined ? 'default' : _ref$alternative,
      props = _objectWithoutProperties(_ref, ['className', 'selected', 'alternative']);

  var classes = useStyles();
  return React.createElement(
    Button,
    _extends({
      className: cx(className, R.prop(alternative + 'Root')(classes), (_cx = {}, _cx[R.prop(alternative + 'Selected')(classes)] = selected, _cx)),
      'aria-pressed': selected,
      ref: ref
    }, props),
    props.children
  );
});

MyButton.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  alternative: PropTypes.string,
  selected: PropTypes.bool,
  children: PropTypes.node
} : {};

export default MyButton;